<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack('dateForm')">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Record a Shift</ion-title>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <el-form class="schedule_form" :model="formsData.dateForm" :rules="formsData.dateForm.rules" :ref="el => formsData.dateForm.ref = el" :label-position="'top'" @submit.prevent="goNext('dateForm')">
                <page-title title="Shift days & hours" subtitle="Select working days of the vacant role and input hours for the shifts"/>
                <template v-for="(formFieldName, index) in formFieldsDays" :key="formFieldName">
                    <div class="single-shift-time">
                        <el-form-item class="schedule_form_checkbox">
                            <div class="schedule_day_select_checkbox">
                                <el-checkbox :disabled="index == 0" v-model="formsData.dateForm[formFieldName].active" @change="()=>{checkFormValidation('dateForm', true, formFieldName); setFormValidation('dateForm', formFieldName, !formsData.dateForm[formFieldName].active)}">
                                    <span class="weekday">{{ $moment(formFieldName, 'DD/MM/YYYY').format('dddd') }}</span>
                                    <span class="date" v-if="isAustralia">{{ $moment(formFieldName, 'DD/MM/YYYY').format('D MMM YYYY') }}</span>
                                    <span class="date" v-else>{{ $moment(formFieldName, 'DD/MM/YYYY').format('MMM DD YYYY') }}</span>
                                </el-checkbox>
                            </div>
                        </el-form-item>
                        <el-form-item class="schedule_form_time" :prop="formFieldName" v-if="formsData.dateForm[formFieldName].active">
                            <ion-item>
                                <ion-datetime v-model="formsData.dateForm[formFieldName].value.timeStart" display-format="h:mm A" minute-values="0,15,30,45" placeholder="Start Time" @ionChange="checkFormValidation('dateForm', true, formFieldName)"></ion-datetime>
                            </ion-item>
                            to
                            <ion-item>
                                <ion-datetime v-model="formsData.dateForm[formFieldName].value.timeEnd" display-format="h:mm A" minute-values="0,15,30,45" placeholder="End Time" @ionChange="checkFormValidation('dateForm', true, formFieldName)"></ion-datetime>
                            </ion-item>
                        </el-form-item>
                    </div>
                </template>


            </el-form>
            <el-button class="primary w-full mt-auto" @click="goNext('dateForm')"
                :disabled="formsData.dateForm.disabled">
                Next
            </el-button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    import {
        onMounted,
        inject,
    } from 'vue';

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        IonTitle,
        IonDatetime,
        IonItem,
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'
    import {
        useRouter,
    } from 'vue-router'
    import formHooks from '@/hooks/form/form'
    import formValidate from '@/hooks/form/validate/validate'
import PageTitle from '@/components/PageTitle/PageTitle.vue';
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

    export default {
        components: {
            IonToolbar,
            IonButton,
            IonButtons,
            IonIcon,
            IonTitle,
            IonDatetime,
            IonItem,
            PageTitle
        },
        directives: {
        },
        setup() {
            const $store = useStore()
            const $router = useRouter()
            const setPageClassGlobal = inject('setPageClassGlobal');
            const isAustralia = isAustraliaRegion();
            const jobCreatePageData = $store.getters.getGuestShiftRecordCreatePageData;
          const setformFieldsDays = () => {
            let dates = [];
            dates = jobCreatePageData.dates
            return dates;
          };


          const formFieldsDays = setformFieldsDays();

            let fields = {};
            const timeStartDefault = moment('8:00 AM', ["h:mm A"]).format();
            const timeEndDefault = moment('5:00 PM', ["h:mm A"]).format();
            const checkboxValue = true;
            const schedule = jobCreatePageData.schedule;

            formFieldsDays.forEach((elementDay, i) => {
                let timeStart = timeStartDefault;
                let timeEnd = timeEndDefault;
                let active = checkboxValue;
                if (schedule && schedule[elementDay]) {
                    if (schedule[elementDay].timeStart) {
                        timeStart = schedule[elementDay].timeStart;
                        timeEnd = schedule[elementDay].timeEnd;
                        active = true
                    } else {
                        active = false
                    }
                }

                if (i == 0) {
                    active = true
                }

                fields[elementDay] = {
                    value: {
                        timeStart: timeStart,
                        timeEnd: timeEnd,
                        date: elementDay
                    },
                    active: active,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'timeRange', callback, setFormValidation);
                        },
                    }, {
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'currentTimeLater', callback, setFormValidation);
                        },
                    }],

                }
            });

            const formsDataArray = {
                dateForm: fields
            };


            const goBack = (formName) => {
                let formValues = getFormValues(formName);
                formFieldsDays.forEach((elementDay) => {
                    if (!formValues[elementDay]) {
                        formValues[elementDay] = {}
                    }
                });
                $store.dispatch('setGuestShiftRecordCreatePageData', {
                    schedule: formValues
                });
                $router.push({
                    name: 'create_guest_shift_date'
                })
            };

            const goNext = (formName) => {
                formsRefs[formName].value.validate((valid) => {
                    if (valid) {
                        let formValues = getFormValues(formName);
                        formFieldsDays.forEach((elementDay) => {
                            if (!formValues[elementDay]) {
                                formValues[elementDay] = {}
                            }
                        });
                        $store.dispatch('setGuestShiftRecordCreatePageData', {
                            schedule: formValues
                        });
                        $router.push({
                            name: 'guest_shift_additional_information',
                        })
                    } else {
                        setFormValidation(formName, false, false);
                        console.log('error submit!!');
                        return false;
                    }
                });
            };

            onMounted(() => {
                setPageClassGlobal('global_job_create_page');
                setFormRefs();
                checkFormValidation('dateForm', true);
            });

            const {
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                getFormValues,
                setFormRefs,
                formsData,
                formsRefs,
            } = formHooks(formsDataArray);

            return {
                formsData,
                formFieldsDays,
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                goBack,
                goNext,
                isAustralia
            }
        },
    }
</script>